import { utils } from 'pixi.js';

import { events } from '../components/events';
import { EVENT_ACTIVITY_START, EVENT_PRIZE_DOWNLOAD, sendCustomEvent } from '../helpers/stats';

export default class Buttons extends utils.EventEmitter {
  private helpButtonActive: boolean;
  private musicButtonActive: boolean;

  private helpButton: HTMLElement | null;
  private musicButton: HTMLElement | null;

  constructor() {
    super();

    this.helpButtonActive = false;
    this.musicButtonActive = false;

    this.helpButton = document.querySelector('.help-activity-button');
    this.musicButton = document.querySelector('.music-button');

    const prizeDownloadButton = document.querySelector('.quest-download-button');
    const contactLink = document.querySelector('.contact-link');
    const gamesLink = document.querySelector('.games-link');

    const hashButtons = document.querySelectorAll('[data-hash]');
    hashButtons.forEach((button) => {
      button.addEventListener('pointerup', () => {
        const hash = button?.getAttribute('data-hash')?.trim();
        //todo ??? trackEvent(ACTION_BUTTON, hash);
        window.location.hash = hash || '';
      });
    });

    this.musicButton && this.musicButton.addEventListener('pointerup', (e) => this.musicButtonClicked(e));
    this.helpButton && this.helpButton.addEventListener('pointerup', (e) => this.helpButtonClicked(e));
    prizeDownloadButton &&
      prizeDownloadButton.addEventListener('pointerup', () => sendCustomEvent(EVENT_PRIZE_DOWNLOAD));
    contactLink && contactLink.addEventListener('pointerup', () => this.buttonClicked('vzkaznik'));
    gamesLink && gamesLink.addEventListener('pointerup', () => this.buttonClicked('dalsi-velikonocni-hry'));
  }

  buttonClicked(param: string) {
    sendCustomEvent(EVENT_ACTIVITY_START, param); // todo check event type / param
  }

  helpButtonClicked(evt: Event) {
    evt.preventDefault();

    this.helpButton?.classList.toggle('off');

    this.helpButtonActive = !this.helpButtonActive;
    this.emit(events.HELP_BUTTON_CLICK, this.helpButtonActive);
  }

  musicButtonClicked(evt: Event) {
    evt.preventDefault();
    this.musicButton?.classList.toggle('off');

    this.musicButtonActive = !this.musicButtonActive;
    this.emit(events.MUSIC_BUTTON_CLICK, this.musicButtonActive);
  }
}
